import _ from "lodash";

import { concatStrings } from "../../lib/utility";

interface UserSummary {
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

const renderUser = (user: UserSummary) => {
  if (user.firstName || user.lastName) {
    return (
      <div className="flex flex-col">
        <div>{concatStrings([user.firstName, user.lastName])}</div>
        <p className="text-gray-300">{user.email ?? user.id}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col">
      <div>{user.id}</div>
      <p className="text-gray-300">{user.email}</p>
    </div>
  );
};

export const User = ({ value }: { value: string }) => {
  const user: UserSummary = JSON.parse(value);
  return renderUser(user);
};
